module.exports = __webpack_public_path__ + "img/poster.262a54fd.png";